module.exports = __webpack_public_path__ + "assets/55fc5e3c3ab208adf599610818c2a9d5.mp3";